// Data for frontend components

export const mockServices = [
  {
    id: 1,
    title: 'CRM & Lead Automation',
    description: 'Automatically capture, qualify, and nurture leads through intelligent workflows that never miss an opportunity.',
    icon: 'Users'
  },
  {
    id: 2,
    title: 'Database Infrastructure',
    description: 'Enterprise-grade Supabase solutions for real-time data management, authentication, and scalable storage.',
    icon: 'Database'
  },
  {
    id: 3,
    title: 'Custom AI Chatbots',
    description: 'Deploy intelligent conversational agents powered by GPT-4 that understand context and deliver results.',
    icon: 'Bot'
  },
  {
    id: 4,
    title: 'API Integrations',
    description: 'Connect your entire tech stack with custom n8n workflows that automate cross-platform operations.',
    icon: 'Workflow'
  }
];

export const mockTechStack = [
  { name: 'n8n', category: 'Automation' },
  { name: 'Supabase', category: 'Database' },
  { name: 'OpenAI', category: 'AI/ML' },
  { name: 'AWS', category: 'Cloud' },
  { name: 'AutoGen', category: 'AI Agents' },
  { name: 'Microsoft Foundry', category: 'AI Platform' },
  { name: 'AWS SageMaker', category: 'ML Platform' },
  { name: 'AWS Bedrock', category: 'Gen AI' }
];

export const mockProcessSteps = [
  {
    step: '01',
    title: 'Audit',
    description: 'We analyze your current workflows to identify automation opportunities and bottlenecks.',
    icon: 'Search'
  },
  {
    step: '02',
    title: 'Build',
    description: 'Our engineers design and develop custom AI agents and n8n workflows tailored to your needs.',
    icon: 'Wrench'
  },
  {
    step: '03',
    title: 'Scale',
    description: 'Deploy production-ready systems that handle increasing workloads without manual intervention.',
    icon: 'TrendingUp'
  }
];
